import './lib/sentryInit';
import React from 'react';
import ReactDOM from 'react-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import { App } from './App';
import { isProductionEnv } from 'utils/env';

if (isProductionEnv) {
  //hotjar.initialize(1782133, 6);
}

ReactDOM.render(<App />, document.getElementById('root'));
